import React from 'react';
// import {  Link  } from 'gatsby';
import {  AnchorLink  } from 'gatsby-plugin-anchor-links';
import '../utils/style.scss';

export default function Nav(){
  return(
    <div className="Nav">
      <p>
        <AnchorLink className="bannerLink" to="#main">
          JUSTIN AND MEGAN
        </AnchorLink>
      </p>
      <div className="Nav-link-container">
        <AnchorLink className="link" to='/#main'>
          Home
        </AnchorLink>
        <AnchorLink className="link" to='/#directions'>
          Directions
        </AnchorLink>
        <AnchorLink className="link" to='/#registry'>
          Registry
        </AnchorLink>
        <AnchorLink className="link" to='/#faq'>
          FAQ
        </AnchorLink>
      </div>
    </div>
  )
}